import { actions } from '../../actions/networking/networking';

export default function networking( state, action ) {
    if( !state ) {
        return {
            conversations: [],
            conversation: false,
            status: false,
        };
    }

    const newState = { ...state };

    switch( action.type ) {
        case actions.SET_ALL_CONVERSATIONS: return setAllConversations( newState, action );
        case actions.SET_CONVERSATION: return setConversation( newState, action );
        case actions.GET_CONVERSATION: return resetConversation( newState );
        case actions.GET_CONVERSATION_ERROR: return getConversationError( newState, action.status );
        case actions.POST_NEW_CONVERSATION: return createConversation( newState, action );
        case actions.POST_SEND_MESSAGE: return sendMessage( newState, action.contents );
        default: return newState;
    }
}

function setAllConversations( newState, action ) {
    newState.conversations = action.conversations;
    newState.pagination = action.pagination;

    return newState;
}

function setConversation( newState, action ) {

    newState.conversation = action.conversation;
    newState.loggedInUser = action.loggedInUser;

    return newState;
}

function resetConversation( newState ) {
    newState.conversation = {};

    return newState;
}

function getConversationError( newState, status ) {

    newState.status = status;

    return newState;
}

function createConversation( newState, action ) {
    newState.message = action.message;

    return newState;
}

function sendMessage( newState, contents ) {
    return newState;
}


// WEBPACK FOOTER //
// src/client/reducers/networking/networking.js